import { SAVED_DASHBOARDS_STATE_KEY } from '@utils/constants';
import { get } from 'lodash';
import { useQueryClient } from 'react-query';
import { SavedDataInterface } from './useSaveSet';

function useGetDataToBeSaved({ pageMeta }): { dataToBeSaved: SavedDataInterface } {
  const pageKey = get(pageMeta, ['page', 'key'], null);
  const queryClient = useQueryClient();
  const dataToBeSaved: SavedDataInterface = queryClient.getQueryData<any>([
    SAVED_DASHBOARDS_STATE_KEY,
    pageKey,
  ]);

  return { dataToBeSaved };
}

export default useGetDataToBeSaved;
